/*!
 * fuga-wishlist.js - Heart toggle + drawer + add-to-cart
 * v2 (2026-05-14) - adds drawer with inline size picker and add-to-bag
 *
 * Storage key: 'fuga.wishlist' = JSON array of {id, handle, title, url, image, price, addedAt}
 * Public API: window.fugaWishlist.{get, add, remove, has, count, clear, openDrawer, closeDrawer}
 */
(function () {
  'use strict';

  if (window.__fugaWishlistInit) return;
  window.__fugaWishlistInit = true;

  var STORAGE_KEY = 'fuga.wishlist';
  var PRODUCT_CACHE = window.__fugaProductCache = window.__fugaProductCache || {};

  /* Storage primitives */
  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr)); } catch (e) {}
  }
  function has(id) { id = String(id); return read().some(function (it) { return String(it.id) === id; }); }
  function add(snapshot) {
    var arr = read(); var id = String(snapshot.id);
    if (arr.some(function (it) { return String(it.id) === id; })) return arr;
    arr.unshift({
      id: snapshot.id, handle: snapshot.handle, title: snapshot.title, url: snapshot.url,
      image: snapshot.image, price: snapshot.price, addedAt: Date.now()
    });
    write(arr); return arr;
  }
  function remove(id) {
    id = String(id);
    var arr = read().filter(function (it) { return String(it.id) !== id; });
    write(arr); return arr;
  }
  function toggle(snapshot) {
    if (has(snapshot.id)) { remove(snapshot.id); return false; }
    add(snapshot); return true;
  }
  function count() { return read().length; }

  /* Heart sync */
  function syncButton(btn) {
    var id = btn.getAttribute('data-product-id');
    var on = has(id);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Von Wishlist entfernen' : 'Auf Wishlist setzen');
    btn.classList.toggle('fuga-pc__wish--on', on);
  }
  function syncAllButtons() {
    var btns = document.querySelectorAll('[data-fuga-wish]');
    for (var i = 0; i < btns.length; i++) syncButton(btns[i]);
  }
  function syncCounters() {
    var n = count();
    var els = document.querySelectorAll('[data-fuga-bb-wishlist-count], [data-fuga-wishlist-count], [data-fuga-wish-drawer-count]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.textContent = String(n);
      if (el.hasAttribute('data-fuga-wish-drawer-count')) continue;
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    }
  }

  function cssEsc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : s.replace(/"/g, '\\"'); }

  /* Heart click delegate */
  function onCardHeartClick(e) {
    var btn = e.target.closest && e.target.closest('[data-fuga-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var snapshot = {
      id: btn.getAttribute('data-product-id'),
      handle: btn.getAttribute('data-product-handle'),
      title: btn.getAttribute('data-product-title'),
      url: btn.getAttribute('data-product-url'),
      image: btn.getAttribute('data-product-image'),
      price: btn.getAttribute('data-product-price')
    };
    var nowOn = toggle(snapshot);
    btn.classList.add('fuga-pc__wish--pulse');
    setTimeout(function () { btn.classList.remove('fuga-pc__wish--pulse'); }, 380);
    var sameId = document.querySelectorAll('[data-fuga-wish][data-product-id="' + cssEsc(String(snapshot.id)) + '"]');
    for (var i = 0; i < sameId.length; i++) syncButton(sameId[i]);
    syncCounters();
    if (!nowOn) renderDrawerList();
    renderWishlistPage();
    try { window.dispatchEvent(new CustomEvent('fuga:wishlist:change', { detail: { id: snapshot.id, on: nowOn, sourceBtn: btn } })); } catch (e2) {}
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Wishlist page (full /pages/wishlist) */
  function renderWishlistPage() {
    var grid = document.querySelector('[data-fuga-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-fuga-wishlist-empty]');
    var countEl = document.querySelector('[data-fuga-wishlist-page-count]');
    var items = read();
    if (countEl) countEl.textContent = String(items.length);
    if (items.length === 0) {
      grid.innerHTML = ''; grid.setAttribute('hidden', '');
      if (empty) empty.removeAttribute('hidden');
      return;
    }
    if (empty) empty.setAttribute('hidden', '');
    grid.removeAttribute('hidden');
    var html = '';
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      html += '<article class="fuga-pc" data-fuga-product-card data-product-id="' + esc(it.id) + '">';
      html +=   '<div class="fuga-pc__media">';
      html +=     '<a href="' + esc(it.url) + '" class="fuga-pc__media-link" aria-label="' + esc(it.title) + '">';
      if (it.image) {
        html +=     '<img src="' + esc(it.image) + '" alt="' + esc(it.title) + '" class="fuga-pc__img fuga-pc__img--primary" loading="lazy" width="600" height="900">';
      }
      html +=     '</a>';
      html +=     '<button type="button" class="fuga-pc__wish fuga-pc__wish--on" data-fuga-wish';
      html +=       ' data-product-id="' + esc(it.id) + '" data-product-handle="' + esc(it.handle) + '"';
      html +=       ' data-product-title="' + esc(it.title) + '" data-product-url="' + esc(it.url) + '"';
      html +=       ' data-product-image="' + esc(it.image) + '" data-product-price="' + esc(it.price) + '"';
      html +=       ' aria-label="Von Wishlist entfernen" aria-pressed="true">';
      html +=       '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
      html +=         '<path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>';
      html +=       '</svg>';
      html +=     '</button>';
      html +=   '</div>';
      html +=   '<div class="fuga-pc__body">';
      html +=     '<div class="fuga-pc__row">';
      html +=       '<a href="' + esc(it.url) + '" class="fuga-pc__title">' + esc(it.title) + '</a>';
      html +=       '<span class="fuga-pc__price">' + esc(it.price) + '</span>';
      html +=     '</div>';
      html +=   '</div>';
      html += '</article>';
    }
    grid.innerHTML = html;
  }

  /* DRAWER */
  function $drawer() { return document.querySelector('[data-fuga-wish-drawer]'); }
  function $drawerList() { return document.querySelector('[data-fuga-wish-list]'); }
  function $drawerEmpty() { return document.querySelector('[data-fuga-wish-drawer-empty]'); }

  function openDrawer() {
    var d = $drawer(); if (!d) return false;
    d.setAttribute('data-open', 'true');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fuga-wish-open');
    renderDrawerList();
    return true;
  }
  function closeDrawer() {
    var d = $drawer(); if (!d) return;
    d.setAttribute('data-open', 'false');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fuga-wish-open');
  }

  function getLabels() {
    var d = $drawer();
    return {
      size: d && d.getAttribute('data-size-label') || 'Groesse waehlen',
      add: d && d.getAttribute('data-add-label') || 'In den Warenkorb',
      added: d && d.getAttribute('data-added-label') || 'In der Tasche',
      soldout: d && d.getAttribute('data-soldout-label') || 'Ausverkauft'
    };
  }

  function renderDrawerList() {
    var list = $drawerList();
    var empty = $drawerEmpty();
    if (!list) return;
    var items = read();
    if (items.length === 0) {
      list.innerHTML = ''; list.setAttribute('hidden', '');
      if (empty) empty.removeAttribute('hidden');
      return;
    }
    if (empty) empty.setAttribute('hidden', '');
    list.removeAttribute('hidden');
    var labels = getLabels();
    var html = '';
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      html += '<li class="fuga-wish__item" data-fuga-wish-item data-product-id="' + esc(it.id) + '" data-product-handle="' + esc(it.handle) + '">';
      html +=   '<a class="fuga-wish__item-media" href="' + esc(it.url) + '" aria-label="' + esc(it.title) + '">';
      if (it.image) html += '<img src="' + esc(it.image) + '" alt="" loading="lazy">';
      html +=   '</a>';
      html +=   '<div class="fuga-wish__item-body">';
      html +=     '<div class="fuga-wish__item-head">';
      html +=       '<a class="fuga-wish__item-title" href="' + esc(it.url) + '">' + esc(it.title) + '</a>';
      html +=       '<button type="button" class="fuga-wish__item-remove" data-fuga-wish-remove aria-label="Von Wishlist entfernen">&times;</button>';
      html +=     '</div>';
      html +=     '<p class="fuga-wish__item-price">' + esc(it.price) + '</p>';
      html +=     '<div class="fuga-wish__item-variants" data-fuga-wish-variants>';
      html +=       '<button type="button" class="fuga-wish__item-add" data-fuga-wish-add-trigger>' + esc(labels.add) + '</button>';
      html +=     '</div>';
      html +=     '<p class="fuga-wish__item-status" data-fuga-wish-status hidden></p>';
      html +=   '</div>';
      html += '</li>';
    }
    list.innerHTML = html;
  }

  function fetchProduct(handle) {
    if (PRODUCT_CACHE[handle]) return Promise.resolve(PRODUCT_CACHE[handle]);
    var url = (window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'products/' + encodeURIComponent(handle) + '.js';
    return fetch(url, { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (p) { PRODUCT_CACHE[handle] = p; return p; });
  }

  function findSizeOptionIndex(product) {
    if (!product || !product.options) return null;
    for (var i = 0; i < product.options.length; i++) {
      var raw = product.options[i];
      var name = (typeof raw === 'string' ? raw : (raw.name || '')).toLowerCase();
      if (name.indexOf('size') !== -1 || name.indexOf('groesse') !== -1 || name.indexOf('grosse') !== -1) return i + 1;
    }
    return null;
  }
  function findColorOptionIndex(product) {
    if (!product || !product.options) return null;
    for (var i = 0; i < product.options.length; i++) {
      var raw = product.options[i];
      var name = (typeof raw === 'string' ? raw : (raw.name || '')).toLowerCase();
      if (name.indexOf('color') !== -1 || name.indexOf('colour') !== -1 || name.indexOf('farbe') !== -1) return i + 1;
    }
    return null;
  }

  function colorToHex(name) {
    var n = String(name || '').toLowerCase().trim();
    var map = {
      'schwarz': '#000', 'black': '#000', 'onyx': '#000', 'soot': '#000', 'jet': '#000',
      'weiss': '#F0EBE0', 'weiß': '#F0EBE0', 'white': '#F0EBE0', 'off-white': '#F0EBE0', 'offwhite': '#F0EBE0', 'cream': '#F0EBE0', 'natural': '#F0EBE0', 'ivory': '#F0EBE0', 'bone': '#F0EBE0',
      'grau': '#5a5a5a', 'grey': '#5a5a5a', 'gray': '#5a5a5a', 'smoke': '#5a5a5a', 'asphalt': '#5a5a5a',
      'braun': '#4a3a2a', 'brown': '#4a3a2a', 'chocolate': '#4a3a2a', 'tobacco': '#4a3a2a', 'rust': '#4a3a2a',
      'beige': '#c9b894', 'tan': '#c9b894', 'sand': '#c9b894', 'khaki': '#c9b894', 'camel': '#c9b894',
      'olive': '#3a3a2a', 'army': '#3a3a2a', 'military': '#3a3a2a',
      'navy': '#1a2940', 'marine': '#1a2940', 'blau': '#1a2940', 'blue': '#1a2940', 'indigo': '#1a2940',
      'rot': '#5a1a1a', 'red': '#5a1a1a', 'crimson': '#5a1a1a', 'wine': '#5a1a1a', 'burgundy': '#5a1a1a', 'blood': '#5a1a1a',
      'gold': '#B79C6A', 'mustard': '#B79C6A', 'amber': '#B79C6A',
      'silber': '#c0c0c0', 'silver': '#c0c0c0',
      'rosa': '#d8a0a0', 'pink': '#d8a0a0', 'blush': '#d8a0a0',
      'gruen': '#3a4a3a', 'green': '#3a4a3a', 'sage': '#3a4a3a', 'forest': '#3a4a3a',
      'lila': '#3a1a4a', 'purple': '#3a1a4a', 'violet': '#3a1a4a',
      'orange': '#d87a3a', 'peach': '#d87a3a', 'coral': '#d87a3a',
      'gelb': '#d4b94f', 'yellow': '#d4b94f', 'mustard': '#B79C6A',
      'tuerkis': '#3d8a8a', 'turquoise': '#3d8a8a', 'teal': '#3d8a8a', 'cyan': '#3d8a8a',
      'multicolor': 'linear-gradient(45deg, #5a1a1a 0 25%, #c9b894 25% 50%, #1a2940 50% 75%, #3a4a3a 75% 100%)',
      'multi': 'linear-gradient(45deg, #5a1a1a 0 25%, #c9b894 25% 50%, #1a2940 50% 75%, #3a4a3a 75% 100%)'
    };
    if (map[n]) return map[n];
    for (var k in map) { if (n.indexOf(k) !== -1) return map[k]; }
    return '#888';
  }



  function variantLabel(v, sizeIdx) {
    if (sizeIdx) return String(v['option' + sizeIdx] || v.title || '?');
    return v.title || '?';
  }

  function expandSizePicker(itemEl) {
    var handle = itemEl.getAttribute('data-product-handle');
    var variantsBox = itemEl.querySelector('[data-fuga-wish-variants]');
    var labels = getLabels();
    variantsBox.innerHTML = '<p class="fuga-wish__item-loading">' + esc(labels.size) + ' ...</p>';
    fetchProduct(handle).then(function (product) {
      var variants = product.variants || [];
      if (variants.length === 1) {
        return addToBag(itemEl, variants[0].id);
      }
      var sizeIdx = findSizeOptionIndex(product);
      var colorIdx = findColorOptionIndex(product);

      var html = '<p class="fuga-wish__item-size-label">' + esc(labels.size) + '</p>';

      function btn(v, displayLabel, hoverTitle) {
        var avail = v.available;
        var s = '<button type="button" class="fuga-wish__size-btn' + (avail ? '' : ' is-soldout') + '"';
        s += ' data-variant-id="' + v.id + '"';
        if (!avail) s += ' aria-disabled="true"';
        s += ' title="' + esc(hoverTitle) + (avail ? '' : ' - ' + labels.soldout) + '">';
        s += esc(displayLabel);
        s += '</button>';
        return s;
      }

      if (sizeIdx && colorIdx) {
        // Group variants by color
        var groups = {};
        var groupOrder = [];
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var color = String(v['option' + colorIdx] || '');
          if (!(color in groups)) { groups[color] = []; groupOrder.push(color); }
          groups[color].push(v);
        }
        for (var g = 0; g < groupOrder.length; g++) {
          var c = groupOrder[g];
          var groupVariants = groups[c];
          var hex = colorToHex(c);
          var swatchStyle = hex.indexOf('gradient') !== -1 ? hex : hex;
          html += '<div class="fuga-wish__item-color-group">';
          html += '<p class="fuga-wish__item-color-name"><span class="fuga-wish__item-color-dot" style="background:' + swatchStyle + '"></span>' + esc(c) + '</p>';
          html += '<div class="fuga-wish__item-sizes">';
          for (var j = 0; j < groupVariants.length; j++) {
            var v2 = groupVariants[j];
            var sz = String(v2['option' + sizeIdx] || v2.title || '?');
            html += btn(v2, sz, sz + ' / ' + c);
          }
          html += '</div>';
          html += '</div>';
        }
      } else {
        // Single option (just size, just color, or unnamed)
        var optionIdx = sizeIdx || colorIdx;
        html += '<div class="fuga-wish__item-sizes">';
        for (var k = 0; k < variants.length; k++) {
          var v3 = variants[k];
          var lbl = optionIdx ? String(v3['option' + optionIdx] || v3.title || '?') : (v3.title || '?');
          html += btn(v3, lbl, lbl);
        }
        html += '</div>';
      }

      html += '<button type="button" class="fuga-wish__item-add-cancel" data-fuga-wish-add-cancel>Schliessen</button>';
      variantsBox.innerHTML = html;
    }).catch(function (err) {
      variantsBox.innerHTML = '<p class="fuga-wish__item-error">' + esc((window.FUGA_UI||{}).wish_variants_error || 'Konnte Varianten nicht laden.') + '</p><button type="button" class="fuga-wish__item-add" data-fuga-wish-add-trigger>' + esc(labels.add) + '</button>';
    });
  }

  function collapseSizePicker(itemEl) {
    var labels = getLabels();
    var variantsBox = itemEl.querySelector('[data-fuga-wish-variants]');
    if (!variantsBox) return;
    variantsBox.innerHTML = '<button type="button" class="fuga-wish__item-add" data-fuga-wish-add-trigger>' + esc(labels.add) + '</button>';
  }

  function addToBag(itemEl, variantId) {
    var statusEl = itemEl.querySelector('[data-fuga-wish-status]');
    var variantsBox = itemEl.querySelector('[data-fuga-wish-variants]');
    var labels = getLabels();
    if (variantsBox) variantsBox.innerHTML = '<p class="fuga-wish__item-loading">...</p>';
    var body = new URLSearchParams();
    body.set('id', variantId);
    body.set('quantity', '1');
    return fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || ('HTTP ' + r.status)); });
      return r.json();
    })
    .then(function () {
      if (window.fugaCart && typeof window.fugaCart.refresh === 'function') {
        return window.fugaCart.refresh().then(function () {
          if (typeof window.fugaCart.open === 'function') window.fugaCart.open();
        });
      } else {
        var trigger = document.querySelector('[data-cart-toggle]');
        if (trigger) trigger.click();
      }
    })
    .then(function () {
      if (statusEl) {
        statusEl.textContent = labels.added;
        statusEl.removeAttribute('hidden');
        setTimeout(function () { statusEl.setAttribute('hidden', ''); }, 2200);
      }
      collapseSizePicker(itemEl);
    })
    .catch(function (err) {
      if (variantsBox) variantsBox.innerHTML = '<p class="fuga-wish__item-error">' + esc((window.FUGA_UI||{}).wish_add_error || 'Konnte nicht hinzufügen:') + ' ' + esc(err.message || (window.FUGA_UI||{}).unknown || 'unbekannt') + '</p><button type="button" class="fuga-wish__item-add" data-fuga-wish-add-trigger>' + esc(labels.add) + '</button>';
    });
  }

  function onDrawerClick(e) {
    var t = e.target;
    if (!t) return;
    if (t.closest && t.closest('[data-fuga-wish-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    var itemEl = t.closest && t.closest('[data-fuga-wish-item]');
    if (!itemEl) return;
    if (t.closest('[data-fuga-wish-remove]')) {
      e.preventDefault();
      var id = itemEl.getAttribute('data-product-id');
      remove(id);
      var matches = document.querySelectorAll('[data-fuga-wish][data-product-id="' + cssEsc(String(id)) + '"]');
      for (var i = 0; i < matches.length; i++) syncButton(matches[i]);
      syncCounters();
      renderDrawerList();
      renderWishlistPage();
      return;
    }
    if (t.closest('[data-fuga-wish-add-trigger]')) {
      e.preventDefault();
      expandSizePicker(itemEl);
      return;
    }
    if (t.closest('[data-fuga-wish-add-cancel]')) {
      e.preventDefault();
      collapseSizePicker(itemEl);
      return;
    }
    var sizeBtn = t.closest('.fuga-wish__size-btn');
    if (sizeBtn) {
      e.preventDefault();
      if (sizeBtn.getAttribute('aria-disabled') === 'true') return;
      var vid = sizeBtn.getAttribute('data-variant-id');
      if (vid) addToBag(itemEl, vid);
    }
  }

  function onTriggerClick(e) {
    var t = e.target.closest && e.target.closest('[data-fuga-wish-trigger]');
    if (!t) return;
    var d = $drawer();
    if (!d) return;
    e.preventDefault();
    openDrawer();
  }

  function onKeydown(e) {
    if (e.key !== 'Escape') return;
    var d = $drawer();
    if (d && d.getAttribute('data-open') === 'true') closeDrawer();
  }

  function init() {
    document.addEventListener('click', onCardHeartClick, true);
    document.addEventListener('click', onDrawerClick, false);
    document.addEventListener('click', onTriggerClick, false);
    document.addEventListener('keydown', onKeydown);
    syncAllButtons();
    syncCounters();
    renderWishlistPage();
    window.addEventListener('storage', function (e) {
      if (e.key !== STORAGE_KEY) return;
      syncAllButtons(); syncCounters(); renderWishlistPage(); renderDrawerList();
    });
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (muts) {
        var needsSync = false;
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n && n.nodeType === 1 && (n.matches && n.matches('[data-fuga-wish]') || n.querySelector && n.querySelector('[data-fuga-wish]'))) { needsSync = true; break; }
          }
          if (needsSync) break;
        }
        if (needsSync) syncAllButtons();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.fugaWishlist = {
    get: read,
    add: function (s) { add(s); syncAllButtons(); syncCounters(); renderDrawerList(); },
    remove: function (id) { remove(id); syncAllButtons(); syncCounters(); renderDrawerList(); renderWishlistPage(); },
    has: has,
    count: count,
    clear: function () { write([]); syncAllButtons(); syncCounters(); renderDrawerList(); renderWishlistPage(); },
    openDrawer: openDrawer,
    closeDrawer: closeDrawer
  };
})();

/* ── Wishlist add-to-list FX (fly-to-header + burst + count pop + icon nudge) ── */
(function () {
  if (window.__fugaWishFx) return;
  window.__fugaWishFx = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var css = ''
    + '.fuga-wishfx-fly{position:fixed;z-index:100001;pointer-events:none;color:#B79C6A;will-change:transform}'
    + '.fuga-wishfx-fly svg{width:22px;height:22px;display:block}'
    + '.fuga-wishfx-particle{position:fixed;z-index:100001;width:5px;height:5px;border-radius:50%;background:#B79C6A;pointer-events:none}'
    + '@keyframes fugaWishNudge{0%,100%{transform:translateY(0) scale(1)}30%{transform:translateY(-4px) scale(1.1)}60%{transform:translateY(0) scale(.95)}}'
    + '.fuga-wishfx-nudge{animation:fugaWishNudge .5s ease}'
    + '@keyframes fugaWishPop{0%{transform:scale(1)}40%{transform:scale(1.65)}100%{transform:scale(1)}}'
    + '.fuga-icon-btn__count.fuga-wishfx-pop{animation:fugaWishPop .42s ease}'
    + '@media (prefers-reduced-motion:reduce){.fuga-wishfx-nudge,.fuga-wishfx-pop{animation:none}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var HEART = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 21s-7.5-4.9-10-9.2C.4 8.6 2 5 5.3 5c2 0 3.3 1.1 4 2.1C10 6.1 11.3 5 13.3 5 16.6 5 18.2 8.6 16.6 11.8 14.1 16.1 12 21 12 21z"/></svg>';
  var lastBtn = null;

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-fuga-wish]');
    if (b) lastBtn = b;
  }, true);

  function burst(x, y) {
    for (var i = 0; i < 8; i++) {
      var p = document.createElement('div'); p.className = 'fuga-wishfx-particle';
      document.body.appendChild(p);
      p.style.left = x + 'px'; p.style.top = y + 'px';
      var a = Math.PI * 2 * i / 8, d = 16 + Math.random() * 12;
      p.animate([
        { transform: 'translate(-50%,-50%) translate(0,0)', opacity: 1 },
        { transform: 'translate(-50%,-50%) translate(' + Math.cos(a) * d + 'px,' + Math.sin(a) * d + 'px)', opacity: 0 }
      ], { duration: 520, easing: 'cubic-bezier(.2,.7,.2,1)' }).onfinish = function () { this.effect.target.remove(); };
    }
  }

  function fly(from, to) {
    var r1 = from.getBoundingClientRect(), r2 = to.getBoundingClientRect();
    var x1 = r1.left + r1.width / 2, y1 = r1.top + r1.height / 2;
    var x2 = r2.left + r2.width / 2, y2 = r2.top + r2.height / 2;
    var el = document.createElement('div'); el.className = 'fuga-wishfx-fly'; el.innerHTML = HEART;
    document.body.appendChild(el);
    el.style.left = x1 + 'px'; el.style.top = y1 + 'px';
    var dx = x2 - x1, dy = y2 - y1;
    el.animate([
      { transform: 'translate(-50%,-50%) translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(-50%,-50%) translate(' + (dx * 0.5) + 'px,' + (dy * 0.5 - 46) + 'px) scale(1.15)', opacity: 1, offset: 0.55 },
      { transform: 'translate(-50%,-50%) translate(' + dx + 'px,' + dy + 'px) scale(.28)', opacity: 0.15 }
    ], { duration: 720, easing: 'cubic-bezier(.5,0,.3,1)' }).onfinish = function () { el.remove(); };
  }

  window.addEventListener('fuga:wishlist:change', function (e) {
    if (!e.detail || !e.detail.on) return;
    var header = document.querySelector('[data-fuga-wish-trigger]');
    if (!header) return;
    var badge = header.querySelector('.fuga-icon-btn__count');
    header.classList.remove('fuga-wishfx-nudge'); void header.offsetWidth; header.classList.add('fuga-wishfx-nudge');
    if (badge) { badge.classList.remove('fuga-wishfx-pop'); void badge.offsetWidth; badge.classList.add('fuga-wishfx-pop'); }
    if (reduce) return;
    var src = (e.detail && e.detail.sourceBtn) || lastBtn;
    if (src) {
      var r = src.getBoundingClientRect();
      burst(r.left + r.width / 2, r.top + r.height / 2);
      fly(src, header);
    }
  });
})();
